import { FC } from 'react'

import { networkUrl } from 'src/lib/util/network'
import { UsernameMenu } from 'src/components/user/v2/username-menu/menu'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipArrow
} from 'design-system'
import { ArchivedBoardBasicInfoProps } from './types'
import { ClipboardCopyButton } from 'src/components/generics/clipboard-copy/button'
import { gqlDisplayName } from 'shared/lib/user'

const textClassnames = 'text-slate-500 text-base'

export const ArchivedBoardBasicInfo: FC<ArchivedBoardBasicInfoProps> = ({
  board
}) => {
  const { loggedInBoardUser, network, title: boardTitle, owner, id } = board
  const { name: networkName } = network
  const ownerName = gqlDisplayName(owner)
  const isUserOwner = owner.id === loggedInBoardUser.userId
  const communityUrl = `${networkUrl(networkName, `/community/${id}`)}`
  const textToCopy = `Community Title: ${boardTitle}\nCommunity URL: ${communityUrl}\nCommunity Owner: ${ownerName}`

  return (
    <div className="w-full rounded-md bg-slate-100 p-4 text-left">
      <div className="flex justify-between">
        <div className="mb-4">
          <p className={textClassnames}>Community Title: </p>
          <div>{boardTitle}</div>
        </div>
        <Tooltip>
          <TooltipTrigger>
            <ClipboardCopyButton
              className="text-blue-600"
              text={textToCopy}
              label="Copy Community Title"
            />
          </TooltipTrigger>
          <TooltipContent>
            <TooltipArrow className="fill-slate-800" />
            Click to copy community info
          </TooltipContent>
        </Tooltip>
      </div>
      <div className="mb-4">
        <p className={textClassnames}>Community URL: </p>
        <div className="truncate">{communityUrl}</div>
      </div>
      <div>
        <p className={textClassnames}>Community Owner: </p>
        <UsernameMenu
          user={owner}
          messageEnabled={false}
          isOwnProfile={isUserOwner}
        />
      </div>
    </div>
  )
}
